import _regeneratorRuntime from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { baseUrl } from "../../api";
import axios from "axios";
import { contactUs } from "../../api/requests";
export var ValidateInputs = function ValidateInputs(input, setError) {
  var validated = true;

  if (input.Name.length < 3) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        Name: "Name must be 3 characters or longer",
        NameFa: "نام باید ۳ حرف یا بیشتر باشد"
      });
    });
    validated = false;
  }

  if (!input.Name) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        Name: "Name field must be filled",
        NameFa: "پرکردن فیلد نام الزامیست "
      });
    });
    validated = false;
  }

  if (input.TelNum.length !== 11) {
    // console.log("input.TelNum.length", input.TelNum.length)
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        TelNum: "Mobile phone number must be 11 digits long",
        TelNumFa: "شماره تلفن همراه باید 11رقم باشد"
      });
    });
    validated = false;
  }

  if (isNaN(Number(input.TelNum))) {
    // console.log("typeof(input.TelNum) from inside: ", typeof (input.TelNum))
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        TelNum: "Mobile phone number must be only numbers",
        TelNumFa: "شماره تلفن همراه باید فقط عدد باشد"
      });
    });
    validated = false;
  }

  if (!input.TelNum) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        TelNum: "Mobile phone number field must be filled",
        TelNumFa: "پرکردن شماره تلفن همراه الزامیست"
      });
    });
    validated = false;
  }

  function EmailAddIsValid(email) {
    var emailRegexTest = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegexTest.test(email);
  }

  if (EmailAddIsValid(input.EmailAdd) === false) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        EmailAdd: "Email Add must be valid",
        EmailAddFa: "آدرس ایمیل باید استاندارد باشد"
      });
    });
    validated = false;
  }

  if (!input.EmailAdd) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        EmailAdd: "Email Add field must be filled",
        EmailAddFa: "پرکردن فیلد آدرس ایمیل الزامیست"
      });
    });
    validated = false;
  }

  if (input.Msg.length < 3) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        Msg: "Message must be 3 characters or longer",
        MsgFa: "متن پیام باید 3حرف یا بیشتر باشد"
      });
    });
    validated = false;
  }

  if (!input.Msg) {
    setError(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        Msg: "Message field must be filled",
        MsgFa: "پرکردن فیلد متن پیام الزامیست"
      });
    });
    validated = false;
  }

  return validated;
};
export var handleChange = function handleChange(setError, setInput, _ref) {
  var _ref$target = _ref.target,
      name = _ref$target.name,
      value = _ref$target.value;
  setError(null);
  setInput(function (prev) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, value));
  });
};
export var submitMessage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, input, setInput, setError, setServerResponse) {
    var EmailAdd, Msg, Name, TelNum, validated, Url, config, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            EmailAdd = input.EmailAdd, Msg = input.Msg, Name = input.Name, TelNum = input.TelNum;
            validated = ValidateInputs(input, setError);

            if (!validated) {
              _context.next = 18;
              break;
            }

            Url = "".concat(baseUrl, "/contactus");
            config = {
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'POST',
              url: Url,
              data: input
            };
            axios.interceptors.response.use(function (res) {
              // Any status code that lie within the range of 2xx cause this function to trigger
              // Do something with response data
              return res;
            }, function (error) {
              // Any status codes that falls outside the range of 2xx cause this function to trigger
              // Do something with response error
              // setError(prevState => ({...prevState, Code: error.response.data.message}));
              if (error && error.response && error.response.data && error.response.data.message) {
                setServerResponse(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    message: error.response.data.message
                  });
                });
              } else {
                setServerResponse(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    message: "There's been an error, Please try again",
                    messageFa: "مشکلی پیش آمد، لطفا دوباره سعی کنید"
                  });
                });
              }

              return Promise.reject(error);
            });
            _context.prev = 7;
            _context.next = 10;
            return contactUs(Name, TelNum, EmailAdd, Msg);

          case 10:
            res = _context.sent;
            setServerResponse(res.data);

            if (res.data) {
              setServerResponse(function (prevState) {
                return _objectSpread(_objectSpread({}, prevState), {}, {
                  message: "Your message has been submitted successfully",
                  messageFa: "پیام شما با موفقیت ثبت شد"
                });
              });
              setInput({
                Name: "",
                TelNum: "",
                EmailAdd: "",
                Msg: ""
              });
            }

            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](7);
            console.log("error", _context.t0);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 15]]);
  }));

  return function submitMessage(_x, _x2, _x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();